import { Check } from 'lucide-react'

interface StatusChipProps {
  state: 'checked' | 'differs' | 'pending'
  onToggle: () => void
}

export const StatusChip = ({ state, onToggle }: StatusChipProps) => {
  const cfg = {
    checked: {
      label: 'Confere',
      icon: <Check className="h-3 w-3" strokeWidth={3} />,
      cls: 'border-brand-green-primary-4 bg-transparent text-brand-green-primary-6',
    },
    differs: {
      label: 'Confere',
      icon: <span className="h-2.5 w-2.5 rounded-full border border-brand-grayscale-7" />,
      cls: 'border-brand-grayscale-5 bg-brand-grayscale-3 text-brand-grayscale-9',
    },
    pending: {
      label: 'Confere',
      icon: <span className="h-2.5 w-2.5 rounded-full border border-brand-grayscale-7" />,
      cls: 'border-brand-grayscale-5 bg-brand-grayscale-3 text-brand-grayscale-9',
    },
  }[state]

  return (
    <label
      className={`group inline-flex w-[120px] cursor-pointer select-none items-center justify-center gap-1.5 border px-2.5 py-1.5 font-mono text-sm font-semibold tracking-normal transition-colors hover:brightness-95 ${cfg.cls}`}
    >
      <input
        type="checkbox"
        checked={state === 'checked'}
        onChange={onToggle}
        className="sr-only"
      />
      <span className="inline-flex h-3 w-3 shrink-0 items-center justify-center">{cfg.icon}</span>
      <span className="flex-1 text-center">{cfg.label}</span>
    </label>
  )
}
